import { useEffect } from 'react';
import Header from '../../shared/Header/Header';
import Footer from '../../shared/Footer/Footer';
import HeroSection from '../../components/HeroSection/HeroSection';
import PresentationSection from '../../components/PresentationSection/PresentationSection';
import FeaturesSection from '../../components/FeaturesSection/FeaturesSection';
import ModelsSection from '../../components/ModelsSection/ModelsSection';
import PlansSection from '../../components/PlansSection/PlansSection';
import BannerSection from '../../components/BannerSection/BannerSection';
import { initGTM } from '../../utils/analytics';
import { GTM_ID } from '../../values/constants';
import './Home.css';

const Home = () => {
  useEffect(() => {
    // Inicializar Google Tag Manager
    initGTM(GTM_ID);
  }, []);

  return (
    <div className="home">
      <Header />

      <main>
        {/* Portada */}
        <HeroSection />

        {/* Presentación 1 */}
        <PresentationSection />

        {/* Características */}
        <FeaturesSection />

        {/* Banner 1 */}
        <BannerSection variant="1">
          <img src="https://agendalafecha.com/public/img/iconos/icono-corazon.svg" alt="Corazón" />
          <p>
            Sabemos que cada evento es único, por eso te ofrecemos un diseño personalizado <br />y flexible adaptado
            a los requerimientos de cada pareja
          </p>
        </BannerSection>

        {/* Modelos */}
        <ModelsSection />

        {/* Planes de Invitaciones */}
        <PlansSection />

        {/* Banner 2 */}
        <BannerSection variant="2">
          <h3>PERSONALIZAMOS TU INVITACIÓN DE ACUERDO A TUS GUSTOS</h3>
          <p>
            Utilizando la estructura del demo que elijas la diseñamos a medida de tus gustos (portada, colores,
            redacción de textos, imágenes). Contamos con un amplio catálogo con más de 80 diseños para personalizar tu
            invitación
          </p>
          <div className="text-center">
            <a
              href="https://wa.me/+5493815615474/?text=Hola!%20Quiero%20más%20info%20sobre%20las%20invitaciones%20digitales"
              target="_blank"
              rel="noopener noreferrer"
              className="boton-verde"
            >
              ¡Quiero conocer más!
            </a>
          </div>
        </BannerSection>
      </main>
      <Footer />
    </div>
  );
};

export default Home;
